var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 25",
    style: {
      enableBackground: "new 0 0 24 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFE;stroke-linecap:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "person"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    className: "st0",
    d: "M4,20.5c0-3,4-3,6-5c1-1-2-1-2-6c0-3.3,1.3-5,4-5s4,1.7,4,5c0,5-3,5-2,6c2,2,6,2,6,5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonLight);
export default __webpack_public_path__ + "static/media/person-light.fe03fc17ab215ad3614cceb092a7233b.svg";
export { ForwardRef as ReactComponent };